import { cutoutImage } from "../../lib/productImage";

export const fmt = (n) => `${Math.round(n).toLocaleString("fr-BE")}\u00a0€`;

export function minPrice(p) {
  const all = (p.variants || []).filter((x) => x.price > 0);
  const live = all.filter((x) => (x.stock || 0) > 0);
  const st = (p.storages || []).map((s) => s.promo_price || s.price).filter((x) => x > 0);
  const v = live.length ? live.map((x) => x.price) : all.length ? all.map((x) => x.price) : st;
  return v.length ? Math.min(...v) : p.base_price || 0;
}

export function newRef(p) {
  const s = (p.storages || []).filter((x) => x.new_price > 0).sort((a, b) => a.price - b.price);
  return s[0]?.new_price || 0;
}

export const inStock = (p) => p.track_stock === false || (p.variants || []).some((v) => (v.stock || 0) > 0);

export const storages = (p) => (p.storages || []).map((s) => s.label).join(" · ");

const IPHONES = new Set(["12", "12-mini", "12-pro", "12-pro-max", "13", "13-mini", "13-pro", "13-pro-max", "14", "14-plus", "14-pro", "14-pro-max", "15", "15-plus", "15-pro", "15-pro-max", "16", "16-plus", "16-pro", "16-pro-max", "16e", "17", "17-pro", "17-pro-max", "17e", "air"]);

export function officialImg(name = "", single = false) {
  const m = name.toLowerCase().match(/iphone\s+(\d{2}e?|air)(?:\s+(pro max|pro|plus|mini))?/);
  if (!m) return null;
  const k = m[1] + (m[2] ? `-${m[2].replace(" ", "-")}` : "");
  return IPHONES.has(k) ? `/official/${single ? "single/" : ""}iphone-${k}.webp` : null;
}


export const CAT_OFFICIAL = {
  iphone: "/official/iphone-17-pro.webp", samsung: "/official/galaxy-s25-edge.webp", "apple-watch": "/official/apple-watch-series-11.webp",
  montres: "/official/apple-watch-series-11.webp", accessoires: "/official/airpods-pro-3.webp", ipad: "/official/ipad-pro.webp", tablettes: "/official/ipad-air.webp",
};

export const CAT_TITLE = { iphone: "iPhone", ipad: "iPad", "apple-watch": "Apple Watch", macbook: "MacBook", samsung: "Samsung Galaxy", "galaxy-tab": "Galaxy Tab", "galaxy-watch": "Galaxy Watch", google: "Google Pixel" };

export function enrich(p) {
  const price = minPrice(p);
  const ref = newRef(p);
  const imgs = (p.colors || []).map((c) => (c.images || [])[0]).filter(Boolean).slice(0, 3);
  return { ...p, price, ref, save: ref > price ? ref - price : 0, img: cutoutImage(p), imgs: imgs.length ? imgs : [cutoutImage(p)].filter(Boolean), stock: inStock(p) };
}

export const shortName = (n = "") => n.replace(/\s*-\s*Reconditionn[ée]e?/i, "").trim();
